export const dateRange = (state, rootState) => {
	return state.widgetConfig.dateRange;
}

export const viewType = (state, rootState) => {
  return state.widgetConfig.viewType;
}

export const periodType = (state, rootState) => {
  return state.widgetConfig.viewType;
}

export const intervalType = (state, rootState) => {
  return state.widgetConfig.intervalType;
}

export const filters = (state, rootState) => {
  return state.widgetConfig.filters;
}

export const theme = (state, rootState) => {
  return state.widgetConfig.theme;
}
